<template>
    <div class="p-20 v-card v-sheet v-sheet--outlined theme--light mt-3">
        <div class="detail mx-0 mt-2">
            <div class="table-scroll">
                <table class="main-table table-list table-bordered table-width align-table">
                    <thead>
                        <tr>
                            <th class="text-center width-50-px" @click="$emit('add-new-member')"><i class="fa-solid fa-plus cursor-pointer"></i></th>
                            <th class="text-center min-width-150-px">統括部CD</th>
                            <th class="text-center min-width-150-px">カスタマーCD</th>
                            <th class="text-center min-width-150-px">拠点CD</th>
                            <th class="text-center min-width-150-px">担当者ID</th>
                            <th class="text-center width-100-px">並び順</th>
                            <th class="text-center width-100-px">操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="data.folderDetail.members.length > 0">
                            <tr v-for="(item, index) in data.folderDetail.members" :key="item._rowKey || index">
                                <td class="text-start">
                                    <span class="staff-id"> {{ index + 1 }}</span>
                                </td>
                                <td>
                                    <div class="item-group input-search-area d-flex">
                                        <ans-input-search
                                            :id="'MDCD' + index"
                                            type="number"
                                            input-class="custom-border width-70-px"
                                            v-model="item.MDCD"
                                            :maxLength="5"
                                            :onChangeInput="(idx, value) => $emit('refer-md', idx, value, item)"
                                            :is-show-clear="false"
                                            page-search="PopupMST005"
                                            :data-extra="{ company_cd: user.company_cd }"
                                            :auto-close="true"
                                            :isReadonly="false"
                                            @onReferValueName="(value) => $emit('get-md-name', value, item)"
                                            :isDisabled="!user.company_cd"
                                            :isDisabledInput="!user.company_cd"
                                        />
                                        <div class="w-100">
                                            <ans-input
                                                input-class="span-input not_set overflow-dot border-none-dm"
                                                v-model="item.MDName"
                                                id="MDName"
                                                is-required
                                                :maxLength="100"
                                                :isDisabled="true"
                                            />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="item-group input-search-area d-flex">
                                        <ans-input-search
                                            :id="'ClientCD' + index"
                                            type="number"
                                            input-class="custom-border width-70-px"
                                            v-model="item.ClientCD"
                                            :maxLength="8"
                                            :onChangeInput="(idx, value) => $emit('refer-client', idx, value, item)"
                                            :is-show-clear="false"
                                            page-search="PopupMST001"
                                            :data-extra="{ company_cd: user.company_cd }"
                                            :auto-close="true"
                                            :isReadonly="false"
                                            :isDisabled="!user.company_cd"
                                            :isDisabledInput="!user.company_cd"
                                            @onReferValueName="(value) => $emit('get-client-name', value, item)"
                                        />
                                        <div class="w-100">
                                            <ans-input
                                                input-class="span-input not_set overflow-dot border-none-dm"
                                                v-model="item.ClientName"
                                                id="ClientName"
                                                is-required
                                                :maxLength="100"
                                                :isDisabled="true"
                                            />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="item-group input-search-area d-flex">
                                        <ans-input-search
                                            :id="'BranchCD' + index"
                                            v-model="item.BranchCD"
                                            input-class="custom-border"
                                            :is-show-clear="false"
                                            :maxLength="4"
                                            page-search="PopupMST002"
                                            :auto-close="true"
                                            icon="fas fa-search"
                                            :isReadonly="!user.company_cd || !item.ClientCD"
                                            type="number"
                                            :onChangeInput="(idx, value) => $emit('refer-branch', idx, value, item)"
                                            @onReferValueName="(value) => $emit('get-branch-name', value, item)"
                                            :data-extra="{ company_cd: user.company_cd, customer_cd: item.ClientCD, mdcd: item.MDCD }"
                                            :isDisabled="!user.company_cd || !item.ClientCD"
                                            :isDisabledInput="!user.company_cd || !item.ClientCD"
                                        />
                                        <div class="w-100">
                                            <ans-input
                                                input-class="span-input not_set overflow-dot border-none-dm"
                                                v-model="item.BranchName"
                                                id="BranchName"
                                                is-required
                                                :maxLength="100"
                                                :isDisabled="true"
                                            />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="item-group input-search-area d-flex">
                                        <ans-input-search
                                            :id="'UserID' + index"
                                            type="number"
                                            input-class="custom-border"
                                            v-model="item.UserID"
                                            :maxLength="3"
                                            :is-show-clear="false"
                                            page-search="PopupMST003"
                                            :auto-close="true"
                                            :isReadonly="!user.company_cd || !item.ClientCD || !item.BranchCD"
                                            :onChangeInput="(idx, value) => $emit('refer-user', idx, value, item)"
                                            @onReferValueName="(value) => $emit('get-user-name', value, item)"
                                            :data-extra="{ company_cd: user.company_cd, customer_cd: item.ClientCD, location_cd: item.BranchCD }"
                                            :isDisabled="!user.company_cd || !item.ClientCD || !item.BranchCD"
                                            :isDisabledInput="!user.company_cd || !item.ClientCD || !item.BranchCD"
                                            :isRequired-background="true"
                                        />
                                        <div class="w-100">
                                            <ans-input
                                                input-class="span-input not_set overflow-dot border-none-dm"
                                                v-model="item.UserName"
                                                id="UserName"
                                                is-required
                                                :maxLength="100"
                                                :isDisabled="true"
                                            />
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    {{ !item.LineNo ? index + 1 : item.LineNo }}
                                    <a tabindex="1" href="" @click.prevent="$emit('move-up', index)">
                                        <span v-if="data.folderDetail.members.length !== 1"><i class="fa-solid fa-circle-up"></i></span>
                                    </a>
                                    <a tabindex="1" class="ml-5-px" href="" @click.prevent="$emit('move-down', index)">
                                        <span v-if="data.folderDetail.members.length !== 1"><i class="fa-solid fa-circle-down"></i></span>
                                    </a>
                                </td>
                                <td class="text-center">
                                    <span class="delete" @click="$emit('delete-member', index)"><i class="fa-solid fa-trash"></i></span>
                                </td>
                            </tr>
                        </template>
                        <tr v-else class="msg_no_data">
                            <td colspan="7" class="text-center">該当するデータが存在しません。</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'MemberTableExternal',
    props: {},
    computed: { ...mapState('app', ['user', 'isShowLeftMenu', 'dmMessageMode']), ...mapState('MNG_DM_Message_Store', ['data', 'options']) }
};
</script>
